import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { navRef } from '../services/navRef';

export default function NavigateSetter() {
  const navigate = useNavigate();
  useEffect(() => { navRef.current = navigate; }, [navigate]);
  return null;
}
